import {IconButton as MuiIconButton} from "@mui/material";

export const IconButton = MuiIconButton;
